var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClinicalNote = function SvgClinicalNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18506",
    "data-name": "Group 18506",
    transform: "translate(-14477 -817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11897",
    "data-name": "Group 11897",
    transform: "translate(14484 497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894",
    transform: "translate(-7 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7885",
    "data-name": "Path 7885",
    d: "M24.5,0A24.5,24.5,0,1,1,0,24.5,24.5,24.5,0,0,1,24.5,0Z",
    fill: "#f9f9f9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "noun_medical_chart_553563",
    "data-name": "noun_medical chart_553563",
    transform: "translate(14457 789.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10867",
    "data-name": "Path 10867",
    d: "M45.526,6.673H37.155A4.486,4.486,0,0,0,32.531,3a4.52,4.52,0,0,0-4.625,3.673H19.535a1.944,1.944,0,0,0-2.035,1.8V38.747a1.944,1.944,0,0,0,2.035,1.8H45.526a1.944,1.944,0,0,0,2.035-1.8V8.468A1.944,1.944,0,0,0,45.526,6.673ZM43.4,11.161V9.325h1.156V37.89H20.506V9.325h1.156v1.836ZM28.831,7.489V7.081a1.232,1.232,0,0,1,.046-.408,3.765,3.765,0,0,1,7.307,0c0,.122.046.286.046.408v.408h4.625a1.577,1.577,0,0,1,1.526,1.02,1.3,1.3,0,0,1,.092.408v1.428H22.587V8.917a1.3,1.3,0,0,1,.092-.408,1.622,1.622,0,0,1,1.526-1.02ZM46.636,38.747a1.066,1.066,0,0,1-1.11.979H19.535a1.066,1.066,0,0,1-1.11-.979V8.468a1.066,1.066,0,0,1,1.11-.979h2.729a2.269,2.269,0,0,0-.555,1.02H20.09a.486.486,0,0,0-.509.449V38.217a.486.486,0,0,0,.509.449H44.925a.486.486,0,0,0,.509-.449V8.958a.486.486,0,0,0-.509-.449H43.306a2.269,2.269,0,0,0-.555-1.02H45.48a1.066,1.066,0,0,1,1.11.979V38.747Z",
    transform: "translate(12.281 28.315)",
    fill: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10868",
    "data-name": "Path 10868",
    d: "M49.136,14.112A2.519,2.519,0,0,1,46.5,11.806a2.66,2.66,0,0,1,5.273,0A2.519,2.519,0,0,1,49.136,14.112Zm0-3.294a1.093,1.093,0,0,0-1.13.988,1.14,1.14,0,0,0,2.26,0A1.093,1.093,0,0,0,49.136,10.818Z",
    transform: "translate(-4.544 24)",
    fill: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10869",
    "data-name": "Path 10869",
    d: "M44.085,49.556H40.019c-.271,0-.452-.146-.452-.364V46.28H35.952c-.271,0-.452-.146-.452-.364V42.64c0-.218.181-.364.452-.364h3.615V39.364c0-.218.181-.364.452-.364h4.067c.271,0,.452.146.452.364v2.912h3.615c.271,0,.452.146.452.364v3.276c0,.218-.181.364-.452.364H44.537v2.912C44.537,49.411,44.357,49.556,44.085,49.556Zm-3.615-.728h3.163V45.916c0-.218.181-.364.452-.364H47.7V43H44.085c-.271,0-.452-.146-.452-.364V39.728H40.471V42.64c0,.218-.181.364-.452.364H36.4v2.548h3.615c.271,0,.452.146.452.364Z",
    transform: "translate(3.211 9.231)",
    fill: "#6c6c6c"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClinicalNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clinicalNote.8d585e58.svg";
export { ForwardRef as ReactComponent };